'use client';
import { useEffect } from 'react';

/**
 * SecurityWrapper
 * Implements frontend security measures:
 * 1. Disables console logs in production
 * 2. Disables right-click context menu
 * 3. Disables common developer tool keyboard shortcuts
 */
export default function SecurityWrapper({ children }) {
  useEffect(() => {
    // Disabling security wrapper as requested to allow inspect in production
    return;

    // 1. Disable console logs in production (but keep error and warn for debugging)
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    // We keep console.error and console.warn so we can see why it's failing
    // console.warn = noop; 
    // console.error = noop;

    // 2. Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // 3. Disable common developer tool keyboard shortcuts
    const handleKeyDown = (e) => {
      // Disable F12
      if (e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      
      // Disable Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C
      if (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) {
        e.preventDefault();
        return false;
      }
      
      // Disable Ctrl+U (View Source)
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
        return false;
      }

      // Disable Ctrl+S (Save Page)
      if (e.ctrlKey && e.keyCode === 83) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // Clean up
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return children;
}